module.exports = __webpack_public_path__ + "img/dummy-presentation.e84cc1c6.png";